<div class="overflow-x-auto w-full mt-8">
      <table
          class="w-full table border border-b-0 border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden">
          <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
              <tr>
                  <th class="p-2 font-medium text-center border-r border-444 last:border-r-0">No.</th>
                  <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">Produuct Code </th>
                  <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">Qty</th>
                  <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">Amount</th>
                  <th class="p-2 font-medium text-left border-r border-444 last:border-r-0">Status</th>
              </tr>
          </thead>
          <tbody class="text-xs sm:text-sm lg:text-base">
              <tr class="text-444" *ngFor="let product of ordersData; let i = index">
                  <td class="p-2 border-r border-b border-[#D9D9D9] text-center">{{i+1}}</td>
                  <td class="p-2 border-r border-b border-[#D9D9D9]">{{ product.product_code }}</td>
                  <td class="p-2 border-r border-b border-[#D9D9D9]">{{product.quantity}}</td>
                  <td class="p-2 border-r border-b border-[#D9D9D9]">{{product.ordc_labour_charges}}</td>
                  <td
                    class="p-2 border-r border-b border-[#D9D9D9] font-bold"
                    [ngClass]="{
                      'text-red-500': product.ordc_payment_status === 'Unpaid',
                      'text-green-500': product.ordc_payment_status === 'Paid'
                    }"
                  >
                    {{ product.ordc_is_labour_applicable === 1 ? product.ordc_payment_status : '-' }}
                  </td>

              </tr>
          </tbody>
      </table>
  </div>
